var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOurserviceimg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3404 3.14233H3.77081C3.27076 3.14233 2.7912 3.34098 2.43761 3.69457C2.08402 4.04815 1.88538 4.52772 1.88538 5.02777V13.8265C1.88538 14.3265 2.08402 14.8061 2.43761 15.1597C2.7912 15.5133 3.27076 15.7119 3.77081 15.7119H9.42712V16.9689H7.54169C7.375 16.9689 7.21515 17.0351 7.09729 17.1529C6.97942 17.2708 6.91321 17.4307 6.91321 17.5974C6.91321 17.764 6.97942 17.9239 7.09729 18.0418C7.21515 18.1596 7.375 18.2258 7.54169 18.2258H12.5695C12.7362 18.2258 12.8961 18.1596 13.0139 18.0418C13.1318 17.9239 13.198 17.764 13.198 17.5974C13.198 17.4307 13.1318 17.2708 13.0139 17.1529C12.8961 17.0351 12.7362 16.9689 12.5695 16.9689H10.6841V15.7119H16.3404C16.8404 15.7119 17.32 15.5133 17.6736 15.1597C18.0272 14.8061 18.2258 14.3265 18.2258 13.8265V5.02777C18.2258 4.52772 18.0272 4.04815 17.6736 3.69457C17.32 3.34098 16.8404 3.14233 16.3404 3.14233ZM16.3404 14.455H3.77081C3.60413 14.455 3.44427 14.3887 3.32641 14.2709C3.20855 14.153 3.14233 13.9932 3.14233 13.8265V12.5695H16.9689V13.8265C16.9689 13.9932 16.9027 14.153 16.7848 14.2709C16.6669 14.3887 16.5071 14.455 16.3404 14.455Z",
    fill: "#1D6DC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurserviceimg1);
export default __webpack_public_path__ + "static/media/ourserviceimg1.9bdc162df27c375465b224a4b6a3996b.svg";
export { ForwardRef as ReactComponent };